var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDeudasHover68X56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7075_75167)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4635 23.4779V23.4779L25.2836 35.1078L25.2822 35.1126C25.0274 36.0208 25.7133 36.93 26.6701 36.93H41.3301C42.2734 36.93 42.9667 36.0224 42.7167 35.1077L39.5367 23.4779V23.4779C39.3656 22.8531 38.8011 22.42 38.1501 22.42H29.8501C29.2071 22.42 28.6341 22.855 28.4635 23.4779ZM27.0167 23.082C27.3662 21.805 28.5332 20.92 29.8501 20.92H38.1501C39.479 20.92 40.6345 21.8069 40.9835 23.082L44.1636 34.7121C44.6735 36.5775 43.2668 38.43 41.3301 38.43H26.6701C24.7278 38.43 23.3141 36.5808 23.8373 34.7099L27.0167 23.082Z",
    fill: "#2AA288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 18.58C33.3539 18.58 32.8301 19.1038 32.8301 19.75C32.8301 20.3961 33.3539 20.92 34.0001 20.92C34.6463 20.92 35.1701 20.3961 35.1701 19.75C35.1701 19.1038 34.6463 18.58 34.0001 18.58ZM31.3301 19.75C31.3301 18.2754 32.5255 17.08 34.0001 17.08C35.4747 17.08 36.6701 18.2754 36.6701 19.75C36.6701 21.2246 35.4747 22.42 34.0001 22.42C32.5255 22.42 31.3301 21.2246 31.3301 19.75Z",
    fill: "#2AA288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 23.47C34.4143 23.47 34.7501 23.8057 34.7501 24.22V26.1C34.7501 26.5142 34.4143 26.85 34.0001 26.85C33.5859 26.85 33.2501 26.5142 33.2501 26.1V24.22C33.2501 23.8057 33.5859 23.47 34.0001 23.47Z",
    fill: "#2AA288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1401 26.85C33.278 26.85 32.9401 27.3365 32.9401 27.78C32.9401 28.1672 33.2584 28.6335 34.0151 28.8485C34.0412 28.8559 34.0668 28.8647 34.0919 28.8749L34.4295 29.0118C35.5458 29.3534 36.5501 30.2273 36.5501 31.51C36.5501 32.9265 35.388 33.94 33.8501 33.94C33.3312 33.94 32.7941 33.8442 32.3024 33.6643C31.9134 33.522 31.7135 33.0913 31.8558 32.7023C31.9981 32.3133 32.4288 32.1133 32.8178 32.2556C33.1461 32.3757 33.509 32.44 33.8501 32.44C34.7122 32.44 35.0501 31.9534 35.0501 31.51C35.0501 31.1269 34.7369 30.666 33.9681 30.4394C33.9444 30.4324 33.9212 30.4243 33.8983 30.415L33.5638 30.2794C32.4374 29.9449 31.4401 29.0572 31.4401 27.78C31.4401 26.3634 32.6022 25.35 34.1401 25.35C34.6559 25.35 35.2054 25.4447 35.6935 25.6277C36.0813 25.7731 36.2778 26.2055 36.1324 26.5933C35.9869 26.9811 35.5546 27.1776 35.1668 27.0322C34.8548 26.9152 34.4844 26.85 34.1401 26.85Z",
    fill: "#2AA288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 32.43C34.4143 32.43 34.7501 32.7657 34.7501 33.18V35.07C34.7501 35.4842 34.4143 35.82 34.0001 35.82C33.5859 35.82 33.2501 35.4842 33.2501 35.07V33.18C33.2501 32.7657 33.5859 32.43 34.0001 32.43Z",
    fill: "#2AA288"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7075_75167",
    x: -14,
    y: -10,
    width: 96,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.278431 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7075_75167"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7075_75167",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDeudasHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR-DEUDAS-HOVER_68X56.d62ad28982f3c4f44994f0959eb0b50c.svg";
export { ForwardRef as ReactComponent };